import { useMemo } from 'react';
import { Label } from '@/components/ui/label';
import { TextCombobox } from './TextCombobox';
import { Highlight } from './combobox/ComboboxPopup';

type ComboboxInputProps = {
  name: string;
  label: string;
  value: string | null;
  onChange: (val: string | null) => void;
  options: readonly string[];
  placeholder?: string;
};

/** Free-text field with suggestions (the shared `TextCombobox`; empty text → `null`). */
export function ComboboxInput({
  name,
  label,
  value,
  onChange,
  options,
  placeholder,
}: ComboboxInputProps) {
  const text = value ?? '';
  const matches = useMemo(() => {
    const needle = text.trim().toLowerCase();
    return needle ? options.filter((option) => option.toLowerCase().includes(needle)) : options;
  }, [options, text]);

  return (
    <div className="space-y-2">
      <Label htmlFor={name}>
        <span>{label}</span>
      </Label>
      <TextCombobox<string>
        id={name}
        value={text}
        onChange={(raw) => onChange(raw.trim() === '' ? null : raw)}
        options={matches}
        optionValue={(option) => option}
        optionKey={(option) => option}
        renderOption={(option) => <Highlight text={option} query={text} />}
        emptyLabel=""
        hideWhenEmpty
        placeholder={placeholder}
      />
    </div>
  );
}
